import { RouteRecordRaw } from 'vue-router';

export const timerRoutes: RouteRecordRaw[] = [
  { path: '/timer', redirect: '/timer/week' },
  { path: '/timer/', redirect: '/timer/week' },

  {
    path: '/timer/week',
    component: () => import('/@pages/RegistrationWeekPage/RegistrationWeekPage.vue'),
    meta: { gate: 'timer' },
    children: [
      {
        path: ':registrationId',
        component: () => import('/@pages/RegistrationItemPage/RegistrationItemPage.vue'),
        meta: { isModal: true, gate: 'timer' },
      },
    ],
  },

  {
    path: '/timer/day',
    component: () => import('/@pages/RegistrationDayPage/RegistrationDayPage.vue'),
    meta: { gate: 'timer' },
    children: [
      {
        path: ':registrationId',
        component: () => import('/@pages/RegistrationItemPage/RegistrationItemPage.vue'),
        meta: { isModal: true, gate: 'timer' },
      },
    ],
  },

  {
    name: 'NewRegistration',
    path: '/timer/new',
    component: () => import('/@pages/RegistrationCreatePage/RegistrationCreatePage.vue'),
    meta: { gate: 'timer' },
    props: ({ query }) => ({
      projectId: query.projectId != null ? Number(query.projectId) : null,
      createCopy: query.createCopy === 'true',
      userId: query.userId,
      selectUser: query.selectUser === 'true',
    }),
  },

  {
    path: '/timer/registration',
    component: () => import('/@pages/RegistrationCreatePage/RegistrationCreatePage.vue'),
    meta: { gate: 'timer' },
  },

  {
    path: '/timer/registration/:registrationId/edit',
    component: () => import('/@pages/RegistrationCreatePage/RegistrationCreatePage.vue'),
    meta: { gate: 'timer' },
    props: ({ query }) => ({
      createCopy: query.createCopy === 'true',
    }),
  },

  {
    path: '/timer/approval',
    component: () => import('/@pages/RegistrationApprovalPage/RegistrationApprovalPage.vue'),
    meta: { gate: 'timer' },
    children: [
      {
        path: ':registrationId',
        component: () => import('/@pages/RegistrationItemPage/RegistrationItemPage.vue'),
        meta: { isModal: true, gate: 'timer' },
      },
    ],
  },

  {
    path: '/timer/admin',
    component: () => import('/@pages/RegistrationErrorPage/RegistrationErrorPage.vue'),
    meta: { gate: 'timer' },
    children: [
      {
        path: ':registrationId',
        component: () => import('/@pages/RegistrationItemPage/RegistrationItemPage.vue'),
        meta: { isModal: true, gate: 'timer' },
      },
    ],
  },
];
